import Vue from 'vue'

var hub=new Vue(); //中转站

export default hub;